import React, { useState } from 'react';
import {
    Box,
    Tabs,
    Tab,
} from '@mui/material';
import { CandidatesTab } from './CandidatesTab';
import { TopicsTab } from './TopicsTab';
import { ExploreTab } from './ExploreTab';
import TopicBreakdownTab from './TopicBreakdownTab';
import HeatmapTab from './HeatmapTab';
import MentionShareTab from './MentionShareTab';
import { useTranslation } from 'react-i18next';

interface PoliticalStatsVisualizationProps {
    selectedRange: {
        from: string;
        to: string;
        defaultView: 'daily' | 'weekly';
    };
    includeRadio: boolean;
}

export function PoliticalStatsVisualization({ selectedRange, includeRadio }: PoliticalStatsVisualizationProps) {
    const { t } = useTranslation('elecciones');
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Box>
            <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }} variant="scrollable" scrollButtons="auto">
                <Tab label={t('tabs.candidates')} />
                <Tab label={t('tabs.topics')} />
                <Tab label={t('tabs.topicsByCandidate')} />
                <Tab label={t('tabs.heatmap')} />
                <Tab label={t('tabs.compare')} />
                <Tab label={t('tabs.explore')} />
            </Tabs>

            {/* Keep all tabs mounted to preserve cache, but only fetch when active */}
            <Box sx={{ display: activeTab === 0 ? 'block' : 'none' }}>
                <CandidatesTab
                    selectedRange={selectedRange}
                    includeRadio={includeRadio}
                    isActive={activeTab === 0}
                />
            </Box>
            <Box sx={{ display: activeTab === 1 ? 'block' : 'none' }}>
                <TopicsTab
                    selectedRange={selectedRange}
                    includeRadio={includeRadio}
                    isActive={activeTab === 1}
                />
            </Box>
            <Box sx={{ display: activeTab === 2 ? 'block' : 'none' }}>
                <TopicBreakdownTab
                    selectedRange={selectedRange}
                    includeRadio={includeRadio}
                    isActive={activeTab === 2}
                />
            </Box>
            <Box sx={{ display: activeTab === 3 ? 'block' : 'none' }}>
                <HeatmapTab
                    selectedRange={selectedRange}
                    includeRadio={includeRadio}
                    isActive={activeTab === 3}
                />
            </Box>
            <Box sx={{ display: activeTab === 4 ? 'block' : 'none' }}>
                <MentionShareTab
                    selectedRange={selectedRange}
                    includeRadio={includeRadio}
                    isActive={activeTab === 4}
                />
            </Box>
            <Box sx={{ display: activeTab === 5 ? 'block' : 'none' }}>
                <ExploreTab
                    selectedRange={selectedRange}
                    includeRadio={includeRadio}
                    isActive={activeTab === 5}
                />
            </Box>
        </Box>
    );
}
